import React from "react";

export default function ASightLogo(props) {
  const apiBaseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  const defaultBrandingLogoUrl = `${apiBaseUrl}/api/auth/media/branding/a-sight_LOGO_DEF.png`;

  return (
    <img
      src={process.env.REACT_APP_BRANDING_LOGO_URL || defaultBrandingLogoUrl}
      alt="A-Sight Logo"
      style={{ maxWidth: "160px", display: "block", margin: "auto" }}
      {...props}
    />
  );
}
